import React from 'react';
import {create, InstanceProps} from 'react-modal-promise';

import {InlineCohortsModal} from './index';
import type {CohortResult, InlineCohortsModalProps} from './types';

// Creating a wrapper component that handles the modal promise interaction
const InlineCohortsModalWrapper = (props: InlineCohortsModalProps & InstanceProps<CohortResult>) => {
  const {onResolve, onReject, ...modalProps} = props;

  return (
    <div className='inline-cohorts-modal-wrapper'>
      <InlineCohortsModal
        {...modalProps}
        open
        onClose={() => {
          onResolve({
            cohortStagedValue: null,
            cohortSavedValue: null,
          });
        }}
        onCommitCohort={(details) => {
          onResolve({
            cohortStagedValue: details,
            cohortSavedValue: null,
          });
        }}
        onCommitSavedCohort={(details) => {
          onResolve({
            cohortStagedValue: null,
            cohortSavedValue: details,
          });
        }}
      />
    </div>
  );
};

/** Example use: `const {cohortStagedValue, cohortSavedValue} = await promptInlineCohorts(props);` */
export const promptInlineCohorts = create(InlineCohortsModalWrapper);
